import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { getUserOrgs } from '../../../api/users';

import { logoutUser } from '../../auth/login/LoginSlice';
import { STATUS_CODE } from '../../../constants/statusCode';
import {
  checkAndSetLoading,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';
import { saveUserDataToCache } from '../../../utils/userCache';

export const fetchUserOrgs = createAsyncThunk(
  'currentUser/fetchUserOrgs',
  async (params, { signal, rejectWithValue, dispatch }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const response = await getUserOrgs({
        cancelToken: source.token,
      });

      return response.data;
    } catch (error) {
      if (error.response?.status === STATUS_CODE.NOT_FOUND) {
        dispatch(logoutUser());
      }

      return rejectWithValue(error?.response?.status);
    }
  },
);

export const fetchUserOrgsExtraReducers = builder => {
  builder
    .addCase(fetchUserOrgs.pending, (state, action) => {
      checkAndSetLoading(state.userOrgsRequest, action);
    })
    .addCase(fetchUserOrgs.fulfilled, (state, action) => {
      onMatchedRequest(state.userOrgsRequest, action, () => {
        state.organizations = action.payload;
        const orgsByRoles = {};
        Object.entries(action.payload).map(([org, roles]) =>
          roles.map(role => {
            if (!orgsByRoles[role]) {
              orgsByRoles[role] = [];
            }
            orgsByRoles[role].push(org);
            return role;
          }),
        );
        state.orgsByRoles = orgsByRoles;

        saveUserDataToCache(
          {
            organizations: state.organizations,
            orgsByRoles: state.orgsByRoles,
          },
          'organizations',
        );
      });
    })
    .addCase(fetchUserOrgs.rejected, (state, action) => {
      handleRequestRejection(state.userOrgsRequest, action);
    });
};
